import PubSub from "underpub-js";
import Sharer from "sharer.js";
import gsap from 'gsap';

var ShareLinks = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-ShareLinks',
	};

	$.extend(true, this.options, options);

};

ShareLinks.prototype.init = function() {

	var self = this;

	self.shareUrl = self.options.$el.data('shareUrl');
	self.$copyPasteLink = self.options.$el.find(`.${self.options.baseClass}__link--copyPaste`);
	self.$copyPasteIcon = self.$copyPasteLink.find(`.${self.options.baseClass}__link__icon`);
	self.$copyPasteSuccess = self.$copyPasteLink.find(`.${self.options.baseClass}__link__success`);

	self.$copyPasteLink.on('click', function() {
		self.copyPasteLinkClick();
	});

};

ShareLinks.prototype.copyPasteLinkClick = function() {

	const self = this;

	navigator.clipboard.writeText(self.shareUrl);

	gsap.timeline({
		defaults: {
			ease: "power3.out",
		}
	})
	.to(self.$copyPasteIcon, {
		duration: 0.25,
		opacity: 0,
	})
	.to(self.$copyPasteSuccess, {
		duration: 0.15,
		opacity: 1,
		scale: 1,
	}, ">-=0.1")
	.to(self.$copyPasteSuccess, {
		duration: 0.25,
		opacity: 0,
	}, ">+=1.2")
	.to(self.$copyPasteIcon, {
		duration: 0.25,
		opacity: 1,
	}, ">-=0.2")
	.set(self.$copyPasteSuccess, {
		scale: 0,
	})


};

export default ShareLinks;
